import React, { Fragment, useState } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { cn } from 'helpers/utils/classnames';
import SearchIcon from 'icons/search';
import Quicksearch from '../../quicksearch';

const SearchButton = () => {
  const [isDisplayingBanner, setIsDisplayingBanner] = useState<boolean>(false);

  return (
    <Popover>
      {({ close }) => (
        <>
          <Popover.Button
            aria-label="Search button"
            onClick={() => {
              const banner = document.getElementById('siteNoticeBanner');

              setIsDisplayingBanner(banner !== null);
            }}
          >
            <div data-testid="mobile-header-search-button" className="flex flex-col items-center justify-center">
              <div className="size-5">
                <SearchIcon />
              </div>
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Popover.Panel
              className={cn('fixed inset-x-0 z-[3]', {
                'top-[--header-mobile-size]': !isDisplayingBanner,
                'top-[176px]': isDisplayingBanner,
              })}
            >
              <div data-testid="mobile-quicksearch-popup" className="w-full bg-white">
                <Quicksearch className="w-full" closeSearch={close} />
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default SearchButton;
